import { EmployeeProfileBasicSectionTranslation } from './employeeProfile.basic.translation.pl.ts';

export const employeeProfileBasicSectionTranslation: EmployeeProfileBasicSectionTranslation = {
  content: {
    birthDate: '{{years}} years, {{months}} months',
    left: {
      absenceStatus: 'Absence Status',
      expat: {
        false: 'Inactive',
        label: 'Expat Status',
        true: 'Active',
      },
      functionalManager: 'Functional Manager',
      hierarchicalManager: 'Hierarchical Manager',
      hrbp: 'HRBP',
      mtStatus: {
        false: 'No',
        label: 'MT Status',
        true: 'Yes | {{year}}',
      },
    },
    right: {
      departureRisk: 'Departure Risk',
      domesticMobility: 'Domestic Mobility',
      education: 'Education',
      englishLevel: 'English Level',
      internationalMobility: 'International Mobility',
    },
  },
  headerTitle: 'Basic Information',
  headerTitleShorter: 'Basic Information',
};
